export default __webpack_public_path__ + "static/media/american-express.23c49961.svg";